import { FC } from 'react';
import { WbSearch } from '../WbSearch';

interface SearchComponentProps {
  searchValue: string;
  handleChange: (event: any) => void;
}

export const SearchComponent: FC<SearchComponentProps> = ({
  searchValue,
  handleChange,
}) => {
  return (
    <WbSearch value={searchValue} onChange={handleChange} fullWidth={false} />
  );
};
